import { Box } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { CreateInitiativeSubtaskPanel } from 'components/RabbitInitiativeSidePanel/SecondaryPanel/CreateInitiativeSubtaskPanel/CreateInitiativeSubtaskPanel';
import { QUERY_KEYS } from 'components/RabbitInitiativeSidePanel/datahooks';
import { closeSecondaryPanel } from 'components/RabbitInitiativeSidePanel/initiativeSecondaryPanelSlice';
import { useToast } from 'components/hooks/useToast';
import { useSelector, useDispatch } from 'react-redux';
import { initiativeSecondaryPanelSelector } from 'selectors/initiativeSecondaryPanel';

import { isMobileView } from 'constants/helper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { secondaryDrawerWidth } from 'uiToolkitV1/BottomDrawer';

import { setPrimaryScreen, setSecondaryPanelOpen } from '../competencyDrawerSlice';
import { useCreateCompetencyTaskMutation } from '../dataHooks';
import { PrimaryDrawerScreens } from '../types/slice';

export const AddInitiativePanel = () => {
  const dispatch = useDispatch();
  const { mutate: createInitiative } = useCreateCompetencyTaskMutation();
  const queryClient = useQueryClient();

  const toast = useToast();

  const onCollapse = () => {
    dispatch(closeSecondaryPanel({}));
    dispatch(setSecondaryPanelOpen(false));
    dispatch(setPrimaryScreen(PrimaryDrawerScreens.COMPETENCY));
  };

  const { initiativeSubtaskDetails } = useSelector(initiativeSecondaryPanelSelector);

  const handleSaveInitiative = async ({ onSuccess }) => {
    createInitiative(initiativeSubtaskDetails, {
      onError: (err) => {
        // @ts-expect-error Property 'message' does not exist on type 'unknown'
        toast({ title: err.message || `Failed to create new Initiative`, status: 'error' });
      },
      onSuccess: (data) => {
        // @ts-expect-error Property 'entity' does not exist on type 'unknown'
        const newlyCreatedInitiative = data?.entity;
        /* queryClient.invalidateQueries(okrQueryKey);
            queryClient.invalidateQueries(alignmentQueryKey); */

        queryClient.invalidateQueries([QUERY_KEYS.INITIATIVE_SUBTASKS]);
        queryClient.invalidateQueries([REACT_QUERY_KEYS.InitiativeTableData]);
        queryClient.invalidateQueries([REACT_QUERY_KEYS.InitiativeCardsData]);

        toast({ title: `Initiative created successfully.` });
        if (typeof onSuccess === 'function') {
          onSuccess(newlyCreatedInitiative);
        }
      },
    });
  };

  const handleSaveAndExit = () => {
    handleSaveInitiative({ onSuccess: onCollapse });
  };

  const mobileViewProps = isMobileView() ? { minW: '0px', maxW: '100%', width: '100%' } : {};

  return (
    <Box
      h="100%"
      minW={secondaryDrawerWidth}
      maxW={secondaryDrawerWidth}
      backgroundColor="neutral.EBEFF3"
      borderRadius="8px"
      overflow="hidden"
      px={1}
      {...mobileViewProps}
    >
      <CreateInitiativeSubtaskPanel handleSaveAndExit={handleSaveAndExit} onCollapse={onCollapse} />
    </Box>
  );
};
